import { plainText } from '../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';

export enum ConnectionGroupFieldKey {
    LABEL = 'label'
}

export const FORM_CONFIG = {
    [ConnectionGroupFieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.connectionGroupForm.label', defaultMessage: 'Connection Group Label', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
};

export const connectionGroupFormConfigList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
